import ListItemSkeleton from "@/components/Skeleton/ListItemSkeleton";
import ObjectHeaderSkeleton from "@/components/Skeleton/ObjectHeaderSkeleton";
import SectionHeadingSkeleton from "@/components/Skeleton/SectionHeadingSkeleton";

type InteractionsPageSkeletonProps = {
  variant?: "list" | "detail";
};

export default function InteractionsPageSkeleton({ variant = "list" }: InteractionsPageSkeletonProps) {
  if (variant === "detail") {
    return (
      <div className="flex flex-col gap-6" data-testid="interactions-page-skeleton">
        <ObjectHeaderSkeleton />
        <ListItemSkeleton rows={5} />
      </div>
    );
  }

  return (
    <div className="flex flex-col" data-testid="interactions-page-skeleton">
      <SectionHeadingSkeleton />
      <ListItemSkeleton rows={5} />
    </div>
  );
}
